export default {
  login: () => ['post', '/api/auth/login'],
  logout: () => ['post', '/api/auth/logout'],
  refreshJwt: () => ['post', '/api/auth/jwt/refresh'],
};
